import { Redo2, Undo2 } from "lucide-react";
import type { HistoryEventDirection } from "../../../types";

export const LABEL_KEYS: Record<HistoryEventDirection, string> = {
  undo: "smartSurveyor.history.undo",
  redo: "smartSurveyor.history.redo",
};

export const ICONS: Record<HistoryEventDirection, typeof Undo2> = {
  undo: Undo2,
  redo: Redo2,
};
